import { render, staticRenderFns } from "./giftcard-navi.vue?vue&type=template&id=41b1e156&scoped=true&"
import script from "./giftcard-navi.vue?vue&type=script&lang=js&"
export * from "./giftcard-navi.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-navi.vue?vue&type=style&index=0&id=41b1e156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b1e156",
  null
  
)

export default component.exports